<template>
  <div class="certification-mask" v-if="visible">
    <div class="certification-cont">
      <i class="mask-close" @click="onClose"></i>
      <h2 class="cont-title">在校大学生身份验证</h2>
      <p class="cont-stit">享受大学生优惠价</p>
      <div class="form-box">
        <ul class="form-list">
          <li class="form-item">
            <label>
              <i>*</i>
              <span>姓名</span>
            </label>
            <div class="right">
              <input type="text" placeholder="请输入姓名" v-model="formData.name">
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>学历</span>
            </label>
            <div class="right" @click="openPickerMask('education')">
              <div class="text" v-if="formData.education">{{ formData.education }}</div>
              <div class="defult-text has-arrow" v-else>
                <span>请选择学历</span>
                <i class="icon-right"></i>
              </div>
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>学校所在地</span>
            </label>
            <div class="right" @click="openPickerMask('schoolAddress')">
              <div class="text" v-if="formData.schoolAddress">{{ formData.schoolAddress }}</div>
              <div class="defult-text has-arrow" v-else>
                <span>请选择学校所在地</span>
                <i class="icon-right"></i>
              </div>
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>学校名称</span>
            </label>
            <div class="right">
              <input type="text" placeholder="请输入学校名称" v-model="formData.schoolName">
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>入学时间</span>
            </label>
            <div class="right" @click="openPickerMask('admissionDate')">
              <div class="text" v-if="formData.admissionDate">{{ formData.admissionDate }}</div>
              <div class="defult-text" v-else>
                <span>请选择入学时间</span>
                <i class="icon-date"></i>
              </div>
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>预计毕业时间</span>
            </label>
            <div class="right" @click="openPickerMask('graduationDate')">
              <div class="text" v-if="formData.graduationDate">{{ formData.graduationDate }}</div>
              <div class="defult-text" v-else>
                <span>请选择预计毕业时间</span>
                <i class="icon-date"></i>
              </div>
            </div>
          </li>
          <li class="form-item">
            <label>
              <i>*</i>
              <span>请上传学生认证附件</span>
            </label>
          </li>
        </ul>
        <p class="upload-tips">格式要求：jpg、jpeg、bmp、png、gif，不超过5M</p>
        <ul class="upload-list">
          <li class="upload-item">
            <div class="upload-info">
              <i></i>
              <span>学生证封面</span>
            </div>
            <van-uploader
              v-model="fileList1"
              accept=".jpg, .jpeg, .png, .bmp, .gif"
              :max-size="5 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="afterRead1"
              @oversize="onOversize"
              @delete="deleteImage1"
            />
          </li>
          <li class="upload-item">
            <div class="upload-info">
              <i></i>
              <span>学生证内页1</span>
            </div>
            <van-uploader
              v-model="fileList2"
              accept=".jpg, .jpeg, .png, .bmp, .gif"
              :max-size="5 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="afterRead2"
              @oversize="onOversize"
              @delete="deleteImage2"
            />
          </li>
          <li class="upload-item">
            <div class="upload-info">
              <i></i>
              <span>学生证内页2</span>
            </div>
            <van-uploader
              v-model="fileList3"
              accept=".jpg, .jpeg, .png, .bmp, .gif"
              :max-size="5 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="afterRead3"
              @oversize="onOversize"
              @delete="deleteImage3"
            />
          </li>
        </ul>
        <div class="qrcode-box">
          <div class="img-mask">
            <img :src="qrcodeHref" alt="">
          </div>
          <div>
            <p>请务必添加运营老师二维码</p>
            <p>查看学生身份是否审核通过</p>
          </div>
        </div>
        <div class="submit-btn" @click="submit">提交认证</div>
        <div class="agreement-box" @click="agreementChange">
          <div class="radio-box" :class="{active: radioFlag}"></div>
          <div class="agreement-text">
            提交即同意<a @click.stop="openPopup('https://file.boxuegu.com/app/agreement/bxg_service.html')" >《用户服务协议》</a>和<a @click.stop="openPopup('https://file.boxuegu.com/app/agreement/bxg_policy.html')">《隐私政策》</a>
          </div>
        </div>
        <p class="tips">我确认提供的身份信息真实、有效。博学谷有权自行或委托第三方对我<br/>提供的信息进行审查。若提供虚假信息，我自愿承担全部结果。</p>
      </div>
    </div>
    <div class="picker-mask" v-if="maskFlag">
      <!-- 学历 -->
      <van-picker
        v-show="currSelectName === 'education'"
        title="学历"
        show-toolbar
        :columns="educationColumns"
        @confirm="educationConfirm"
        @cancel="onCancel"
      />
      <!-- 学校所在地 -->
      <van-picker 
        v-show="currSelectName === 'schoolAddress'"
        title="学校所在地"
        show-toolbar
        :columns="schoolAddressColumns"
        @confirm="schoolAddressConfirm"
        @cancel="onCancel"
        @change="schoolAddressChange"
      />
      <!-- 时间选择 -->
      <van-datetime-picker
        v-show="currSelectName === 'admissionDate' || currSelectName === 'graduationDate'"
        :title="currSelectName === 'admissionDate' ? '入学时间' : '预计毕业时间'"
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="timePickerConfirm"
        @cancel="onCancel"
      />
    </div>
    <van-popup v-model="popupFlag" position="bottom">
      <iframe :src="popupHref" frameborder="0" ref="iframe"></iframe>
    </van-popup>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { getAllProvince, getCityByProId, uploadFile, onCampusStudent } from "../../../api";
  export default {
    props: ["visible","pageName"],
    name: '',
    data() {
      return {
        maskFlag: false, // 多选弹框（学历、学校所在地、时间）
        radioFlag: false, // 是否同意协议
        popupFlag: false, // 协议弹框
        popupHref: '', // 协议链接
        qrcodeHref: '', // 老师二维码链接
        educationColumns: ['专科', '本科', '硕士', '博士'],
        schoolAddressColumns: [''], // 学校所在地
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(new Date().getFullYear() + 10, 11, 1),
        currentDate: new Date(),
        currSelectName: '', // 当前多选的名称
        fileList1:[], // 上传附件展示的图片
        fileList2:[],
        fileList3:[],
        formData:{
          name: '',
          education: '',
          schoolAddress: '',
          schoolName: '',
          admissionDate: '',
          graduationDate: '',
          attachment1: '',
          attachment2: '',
          attachment3: ''
        }
      }
    },
    mounted(){
      this.getAllProvinceFun()
    },
    methods:{
      openPopup(href){
        this.popupFlag = true
        this.popupHref = href
      },
      // 获取省份
      async getAllProvinceFun(){
        try{
          const { status, data } = await getAllProvince()
          if(status === 200){
            const {success, resultObject} = data
            if(success && resultObject && resultObject.length > 0){
              let arr = []
              resultObject.forEach(val => {
                let obj = {
                  text: val.name,
                  id: val.id,
                  children: ['']
                }
                arr.push(obj)
              });
              this.schoolAddressColumns = arr

              // 第一个省份增加城市
              const currId =  this.schoolAddressColumns[0].id
              let cityArr = [];
              const res2 = await getCityByProId({proId: currId})
              const data2 = res2.data
              if(data2.success){
                data2.resultObject.forEach((item)=>{
                  let obj = {
                    text: item.name
                  }
                  cityArr.push(obj)
                })
              }
              this.schoolAddressColumns[0].children = cityArr
            }
          }
        } catch (err){

        }
      },
      // 关闭弹框
      onClose(){
        this.$emit('update:visible', false)
        this.maskFlag = false
        Object.assign(this.$data, this.$options.data());
      },
      // 是否同意协议
      agreementChange(){
        this.radioFlag = !this.radioFlag
      },
      // 当前打开选择器的表单名称
      openPickerMask(name){
        this.currSelectName = name
        if(name === 'admissionDate'){
          this.minDate = new Date(2010, 0, 1)
          this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
          this.currentDate = new Date()
        } else if (name === 'graduationDate') { 
          this.minDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
          this.maxDate = new Date(new Date().getFullYear() + 10, 11, 1)
          this.currentDate = new Date()
        }
        this.maskFlag = true
      },
      // 学历确认
      educationConfirm(value){
        this.formData.education = value
        this.maskFlag = false
      },
      // 学校所在地确认
      schoolAddressConfirm(value){
        this.formData.schoolAddress = value.join(' / ')
        this.maskFlag = false
      },
      // 学校所在地变化
      async schoolAddressChange(picker){
        const currId = picker.getValues()[0].id
        let cityArr = [];
        const { status, data } = await getCityByProId({proId: currId})
        const {success, resultObject} = data
        if(success){
          resultObject.forEach((item)=>{
            let obj = {
              text: item.name
            }
            cityArr.push(obj)
          })
        }
        picker.setColumnValues(1, cityArr);
        this.schoolAddressColumns.forEach((val)=>{
          if(val.id === currId){
            val.children = cityArr
          }
        })
      },
      // 时间选择器 格式化
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        }
        return val;
      },
      // 时间选择器 确定
      timePickerConfirm(value){
        let dateStr = `${new Date(value).getFullYear()}-${new Date(value).getMonth() + 1 < 10 ? '0' + (new Date(value).getMonth() + 1): new Date(value).getMonth() + 1}`
        if(this.currSelectName === 'admissionDate'){
          this.formData.admissionDate = dateStr
        }else{
          this.formData.graduationDate = dateStr
        }
        this.maskFlag = false
      },
      // 弹框关闭
      onCancel(){
        this.maskFlag = false
      },
      // 上传1
      afterRead1(file){
        let params = new FormData();
        params.append("file", file.file);
        params.append("fileType", 1);
        uploadFile(params).then(res=>{
          if(res.status == 200 && res.data.status === 200){
            this.formData.attachment1 = res.data.result.url
          }else{
            Toast('上传失败')
            this.fileList1 = []
          }
        })
      },
      // 上传2
      afterRead2(file){
        let params = new FormData();
        params.append("file", file.file);
        params.append("fileType", 1);
        uploadFile(params).then(res=>{
          if(res.status == 200 && res.data.status === 200){
            this.formData.attachment2 = res.data.result.url
          }else{
            Toast('上传失败')
            this.fileList2 = []
          }
        })
      },
      // 上传3
      afterRead3(file){
        let params = new FormData();
        params.append("file", file.file);
        params.append("fileType", 1);
        uploadFile(params).then(res=>{
          if(res.status == 200 && res.data.status === 200){
            this.formData.attachment3 = res.data.result.url
          }else{
            Toast('上传失败')
            this.fileList3 = []
          }
        })
      },
      deleteImage1(){
        this.formData.attachment1 = ''
      },
      deleteImage2(){
        this.formData.attachment2 = ''
      },
      deleteImage3(){
        this.formData.attachment3 = ''
      },
      // 上传文件类型判断
      beforeRead(file) {
        let fileType = ['image/jpeg', 'image/bmp', 'image/png', 'image/gif']
        if (fileType.indexOf(file.type) === -1) {
          Toast('请上传 jpg、jpeg、bmp、png、gif 格式图片');
          return false;
        }
        return true;
      },
      // 上传文件size校验
      onOversize(file) {
        Toast('图片大小不能超过5M')
      },
      // 表单校验
      verification(){
        let reg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
        if(!this.formData.name){
          Toast('请输入姓名')
          return false
        } else if (this.formData.name.length > 20) {
          Toast('姓名字符长度需小于20字')
          return false
        } else if (!reg.test(this.formData.name)) {
          Toast('姓名格式不正确')
          return false
        } else if (!this.formData.education) {
          Toast('请选择学历')
          return false
        } else if (!this.formData.schoolAddress) {
          Toast('请选择学校所在地')
          return false
        } else if (!this.formData.schoolName) {
          Toast('请输入学校名称')
          return false
        } else if (this.formData.schoolName.length > 50) {
          Toast('学校名称字符长度需小于50字')
          return false
        } else if (!reg.test(this.formData.schoolName)) {
          Toast('学校名称格式不正确')
          return false
        } else if (!this.formData.admissionDate) {
          Toast('请选择入学时间')
          return false
        } else if (!this.formData.graduationDate) {
          Toast('请选择预计毕业时间')
          return false
        } else if (!this.formData.attachment1) {
          Toast('请上传学生证封面')
          return false
        } else if (!this.formData.attachment2) {
          Toast('请上传学生证内页一')
          return false
        } else if (!this.formData.attachment3) {
          Toast('请上传学生证内页二')
          return false
        } else {
          return true
        }
      },
      // 提交表单
      async submit(){
        if(this.loading) return
        // 校验没通过
        if(!this.verification()) return
        // 是否勾选同意协议
        if(!this.radioFlag){
          Toast('请勾选同意《用户服务协议》和《隐私政策》')
          return
        }
        this.loading = true
        const { status, data } = await onCampusStudent(this.formData)
        if(status != 200) {
          Toast('网络异常，请稍后再试')
          return
        } else {
          if(data.code === 200){
            Toast('提交成功')
            setTimeout(()=>{
              this.onClose()
            }, 1000)
          }else{
            Toast(data.desc)
          }
        }
        setTimeout(()=>{
          this.loading = false
        }, 2000)
        let qrcodeType = localStorage.getItem('qrcodeType')
        const diffName=qrcodeType===1? '在校生报名考试':'在校生报名课程'
        this.mai(this.pageName,'提交认证',0,diffName)
      }
    },
    watch:{
      visible(value){
        if(value){
          this.getAllProvinceFun()
          let qrcodeType = localStorage.getItem('qrcodeType')
          if(qrcodeType == 1){
            // 认证的大学生二维码
            this.qrcodeHref = require('../../../assets/coursePage/common/certification/pic-qrcode-1.jpg')
          }else if(qrcodeType == 2){
            // 认证 + 课程大学生二维码
            this.qrcodeHref = require('../../../assets/coursePage/common/certification/pic-qrcode-2.jpg')
          }
          document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
        }else{
          document.getElementsByTagName('html')[0].style.overflowY = 'visible'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.certification-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  .certification-cont{
    padding: 72px 32px 52px;
    background-image: url(../../../assets/coursePage/common/certification/certification-bg.png);
    background-size: cover;
    position: relative;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    .mask-close{
      width: 32px;
      height: 32px;
      background-image: url(../../../assets/coursePage/common/certification/icon-close.png);
      background-size: 100% 100%;
      position: absolute;
      top: 48px;
      right: 48px;
    }
    .cont-title{
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3E47;
      line-height: 52px;
      text-align: center;
    }
    .cont-stit{
      margin-top: 12px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4E5969;
      line-height: 44px;
    }
    .form-box{
      padding: 0 32px 8px;
      background: #FFFFFF;
      border-radius: 32px 32px 0 0;
      margin-top: 34px;
      .form-list{
        .form-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 32px 0 30px;
          border-bottom: 1.5px solid #E5E6EB;
          height: 104px;
          box-sizing: border-box;
          label{
            position: relative;
            display: flex;
            align-items: center;
            i{
              color: #F53F3F;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #F53F3F;
              line-height: 24px;
              margin-right: 10px;
            }
            span{
              font-size: 30px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #4E5969;
              line-height: 24px;
            }
          }
          .right{
            padding-right: 20px;
            .text{
              font-size: 30px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1D2129;
              line-height: 42px;
            }
            .defult-text{
              display: flex;
              &.has-arrow{
                transform: translateX(6px);
              }
              span{
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #C9CDD4;
                line-height: 30px;
              }
              >i{
                width: 32px;
                height: 32px;
                background-size: 100% 100%;
                margin-left: 8px;
              }
              .icon-right{
                background-image: url(../../../assets/coursePage/common/certification/icon-right.png);
              }
              .icon-date{
                background-image: url(../../../assets/coursePage/common/certification/icon-date.png);
              }
            }
            input{
              font-size: 30px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1D2129;
              line-height: 42px;
              padding: 0;
            }
          }

          &:last-child{
            border: 0;
            padding-bottom: 5px;
          }
        }
      }
      .upload-tips{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        line-height: 40px;
        padding: 0 16px;
      }
      .upload-list{
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        .upload-item{
          width: 180px;
          height: 100px;
          background: #F2F6FB;
          border-radius: 8px;
          position: relative;
          .upload-info{
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            i{
              width: 24px;
              height: 24px;
              display: block;
              margin: 16px auto 0;
              background-image: url(../../../assets/coursePage/common/certification/icon-add.png);
              background-size: 100% 100%;
            }
            span{
              display: block;
              margin-top: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #86909C;
              line-height: 36px;
              text-align: center;
            }
          }
          ::v-deep{
            .van-uploader{
              width: 100%;
              height: 100%;
              .van-uploader__wrapper{
                width: 100%;
                height: 100%;
                .van-uploader__preview{
                  width: 100%;
                  height: 100%;
                  margin: 0;
                  .van-image{
                    width: 100%;
                    height: 100%;
                  }
                  .van-uploader__preview-delete{
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    top: 0;
                    right: 0;
                  }
                }
                .van-uploader__upload{
                  width: 100%;
                  height: 100%;
                  margin: 0;
                  background-color: transparent;
                  .van-icon{
                    display: none;
                  }
                }
              }
            }
          }
        }
      }
      .submit-btn{
        margin-top: 32px;
        width: 622px;
        height: 96px;
        background: linear-gradient(270deg, #98BDFF 0%, #4386FE 100%);
        border-radius: 8px;
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 96px;
      }

      .agreement-box{
        display: flex;
        align-items: center;
        margin-top: 24px;
        .radio-box{
          width: 24px;
          height: 24px;
          background-image: url(../../../assets/coursePage/common/certification/icon-radio.png);
          background-size: 100% 100%;
          margin-right: 14px;
          &.active{
            background-image: url(../../../assets/coursePage/common/certification/icon-radio-active.png);
          }
        }
        .agreement-text{
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #86909C;
          line-height: 40px;
          a{
            color: #255AFF;
          }
        }
      }
      .tips{
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        line-height: 28px;
        margin-top: 8px;
      }
      .qrcode-box{
        margin: 60px auto 0;
        width: 622px;
        height: 172px;;
        background-image: url(../../../assets/coursePage/common/certification/qrcode-box-bg.png);
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 22px 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img-mask{
          width: 128px;
          height: 128px;
          background: #fff;
          border-radius: 8px;
          border: 2px solid #E17F15;
          overflow: hidden;
          padding: 2px;
          box-sizing: border-box;
          img{
            width: 121px;
            height: 121px;
          }
        }
        div{
          height: 88px;
          p{
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF6C13;
            line-height: 44px;
          }
          p:last-child{
            color: #494949;
          }
        }
      }
    }
  }

  ::v-deep{
    .van-popup--bottom{
      height: 80%;
      overflow: hidden;
      iframe{
        width: 100%;
        height: 100%;
        overflow: hidden;
        html,body{
          overflow: hidden !important;
        }
      }
    }
  }
}
input{
  border: 0;
  text-align: right;
  &::placeholder{
    color: #C9CDD4;
  }
}
.picker-mask{
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 400;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  ::v-deep {
    .van-picker{
      position: absolute;
      bottom:0;
      left: 0;
      width: 100%;
      border-radius: 16px 16px 0 0;
      .van-picker__toolbar{
        height: 90px;
        border-bottom: 2px solid #E5E6EB;
        .van-picker__title{
          line-height: 90px;
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1D2129;
          line-height: 42px;
        }
        .van-picker__cancel{
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #86909C;
          line-height: 90px;
          padding: 0 32px;
        }
        .van-picker__confirm{
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #165DFF;
          line-height: 90px;
          padding: 0 32px;
        }
      }
      .van-picker__columns{
        .van-picker-column__wrapper{
          .van-ellipsis{
            font-size: 40px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1D2129;
            line-height: 56px;
          }
        }
      }
    }
  }
}
</style>